// extracted by mini-css-extract-plugin
export var measureBox = "_47-0";